import { render, staticRenderFns } from "./PrintMenu.vue?vue&type=template&id=9ecc5cf4&"
import script from "./PrintMenu.vue?vue&type=script&lang=js&"
export * from "./PrintMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QCard,QCardSection,QTable,QSeparator,QBtn,QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QCard,QCardSection,QTable,QSeparator,QBtn,QToggle})
